(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery"], factory);
	else if(typeof exports === 'object')
		exports["ibm-gantt-chart"] = factory(require("jquery"));
	else
		root["ibm-gantt-chart"] = factory(root["jQuery"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__6__) {
return 